import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'How do I receive the package after purchasing?',
  a: 'You will receive immediate access to all the material so you can start using it right away — no waiting, no complicated steps.'
}, {
  q: 'What level of BJJ instructor is this designed for?',
  a: 'The system is designed for instructors who teach beginner and developing students — from their very first class through to the intermediate level. It works whether you have been teaching for months or for years and simply want to stop planning from scratch every week.'
}, {
  q: 'Does this work for BJJ instructors in any country?',
  a: 'Yes. The system is in English and is designed to work in any academy, garage gym, school program or training environment — regardless of country or affiliation.'
}, {
  q: 'Can I edit the material?',
  a: 'The material is delivered in ready-to-use PDF format. It is designed so you do not need to edit it — you open it, read it and teach it. If you need to adapt it to your specific context, the content is clear and structured enough to use as a strong foundation.'
}, {
  q: 'What currency will I pay in?',
  a: 'The price is displayed in USD, but the system automatically detects your country and adapts the payment to your local currency.'
}, {
  q: 'What if it doesn’t work for me?',
  a: 'You have 7 days to explore everything. If it is not what you need, we will refund 100% of your money. No questions asked.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-carbon" data-id="element-133" data-mp="wz7af2hx55ac">
      <div className="max-w-3xl mx-auto" data-id="element-134" data-mp="wvt79s1fks1u">
        <div className="text-center mb-16" data-id="element-135" data-mp="iy4nknj3nqyd">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white" data-id="element-136" data-mp="j0hdpnz0h7mi">
            Frequently Asked <span className="text-gold" data-id="element-137" data-mp="mz6r3gk1up65">Questions</span>
          </h2>
        </div>
        <div className="space-y-4" data-id="element-138" data-mp="2po7yljz2dawy">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-carbon-graphite border border-carbon-line rounded-xl overflow-hidden" data-id="element-139" data-mp="2kuvn8bjeb0m5" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-gold" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-140" data-mp="2fxlq09prlknr">
                <span className="font-bold text-lg text-white pr-8" data-id="element-141" data-mp="2yn1q4vxjfb3n">{faq.q}</span>
                <ChevronDownIcon className={`text-gold transition-transform duration-200 shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-142" data-mp="2yp65ca0vzwj8" />
              </button>
              <AnimatePresence initial={false} data-id="element-143" data-mp="1j6bay7osb0ad">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-144" data-mp="3uupoetsprsh5">
                    <div className="px-6 pb-5 text-smoke border-t border-carbon-line pt-4" data-id="element-145" data-mp="ci07yxmjv375">{faq.a}</div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}